import ToollBar from "./Toollbar";
import ListBoard from './ListBoard';
import { IOccurrence } from "../types";
import { SelectOption } from "@rio-cloud/rio-uikit";

interface Props {
    data: IOccurrence[];
    handleSearch: (text: string) => void;
    handleDn: (text: string) => void;
    handleResponsible: (text: string) => void;
    handleSupportType: (subject: string) => void;
    isLoading: boolean;
    optionsRegionals: SelectOption[];
    handleRegional: (subject: string) => void;
}

const SupportBoard = ({data, handleSearch, handleSupportType, handleDn, handleResponsible, isLoading, optionsRegionals, handleRegional}: Props) => {
    return (
        <div>
            <ToollBar 
                handleSearch={handleSearch} 
                handleSupportType={handleSupportType} 
                handleDn={handleDn} 
                handleResponsible={handleResponsible}
                optionsRegionals={optionsRegionals}
                handleRegional={handleRegional}
            />
            <ListBoard data={data} isLoading={isLoading} />
        </div>
    )
}

export default SupportBoard;